import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { visibleGroups, groupKey } from "@/lib/nav";
import TileArt from "@/components/TileArt";

/** Pagina de start: plăci mari, câte una pentru fiecare modul și pentru paginile personale (Panou de control, Contul meu, Notificări…). */
export default function Home() {
  const { user, hasRole, hasModule, allowed, activationRequired } = useAuth();
  const [isClientInstall, setIsClientInstall] = useState(false);
  useEffect(() => { api.get("/config/deployment").then(r => setIsClientInstall(!!r.data.is_client_install)).catch(() => {}); }, []);
  const groups = visibleGroups({ hasRole, hasModule, allowed, activationRequired, isClientInstall, theme: "purple" });
  const tiles = [];
  for (const g of groups) {
    if (g.title === "Dashboard") g.items.forEach(it => tiles.push({ key: it.to, label: it.label, to: it.to }));
    else tiles.push({ key: g.title, label: g.title.replace("PlanCo - ", "PlanCo — "), to: g.items.length === 1 ? g.items[0].to : `/m/${groupKey(g)}`, sub: g.items.length > 1 ? `${g.items.length} pagini` : "" });
  }
  return (
    <div data-testid="home">
      <h1 style={{ fontSize: 26, fontWeight: 800, margin: "4px 0 6px" }}>Bine ai venit{user?.name ? `, ${user.name.split(" ")[0]}` : ""}</h1>
      <div style={{ color: "#6B6B6B", marginBottom: 18, fontSize: 15 }}>Alege un modul pentru a începe.</div>
      <div className="tiles">
        {tiles.map(t => (
          <Link key={t.key} to={t.to} className="tile" data-testid={`tile-${t.to.replace(/\//g, "-").replace(/^-/, "")}`}>
            <TileArt /><span>{t.label}{t.sub && <span className="sub">{t.sub}</span>}</span>
          </Link>))}
      </div>
    </div>
  );
}
